import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import { FC } from "react"
import { SectionProps } from "./SectionType"

const SectionFour: FC<SectionProps> = ({ id, children }) => {
  return (
    <section id={id} className={classNames(styles.sectionMedium, styles.sectionFour)}>
      {children}
    </section>
  )
}

export default SectionFour
